import { Card, Flex, Tooltip, Typography } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, InfoCircleOutlined, PercentageOutlined } from "@ant-design/icons";
import { nombreDePeriodo, type DashboardPeriod } from "../../utils";
import { estadoDeWidget, WidgetPlaceholder } from "../widget-state";
import type { WidgetDataProps } from "../../types";

const { Text } = Typography;

const CARD_HEAD = 38;



const Bar = ({ actual, anterior }: { actual: number; anterior: number }) => (
  <div>
    <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 3 }}>
      <div style={{ flex: 1, height: 6, background: "rgba(0,0,0,0.06)", borderRadius: 3, overflow: "hidden" }}>
        <div style={{ width: `${actual}%`, height: "100%", background: "#15744b", borderRadius: 3, transition: "width 0.4s ease" }} />
      </div>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <div style={{ flex: 1, height: 6, background: "rgba(0,0,0,0.06)", borderRadius: 3, overflow: "hidden" }}>
        <div style={{ width: `${anterior}%`, height: "100%", background: "rgba(0,0,0,0.15)", borderRadius: 3, transition: "width 0.4s ease" }} />
      </div>
    </div>
  </div>
);

type Datos = {
  convertidos: number;
  total: number;
  tasa: number | null;
  anterior: { tasa: number | null } | null;
};

export const TasaConversionChip = ({
  height = 240,
  period = "day",
  data,
  estado,
  error,
  nuncaCalculado,
  recargar,
}: { height?: number; period?: DashboardPeriod } & WidgetDataProps<Datos>) => {
  const status = estadoDeWidget(estado, error, nuncaCalculado, (data?.total ?? 0) > 0, recargar);

  const converted = data?.convertidos ?? 0;
  const total = data?.total ?? 0;
  const rate = Math.round((data?.tasa ?? 0) * 100);
  const prevRate = Math.round((data?.anterior?.tasa ?? 0) * 100);
  const bodyH = height - CARD_HEAD;
  const diff  = rate - prevRate;
  const up    = diff > 0;
  const color = up ? "#15744b" : "#cf1322";
  const Icon  = up ? ArrowUpOutlined : ArrowDownOutlined;

  return (
    <Card
      size="small"
      style={{ height }}
      styles={{ body: { padding: "12px 16px", height: bodyH, display: "flex", flexDirection: "column", justifyContent: "center", gap: 10 } }}
      title={
        <Flex align="center" gap={8}>
          <PercentageOutlined style={{ fontSize: 14 }} />
          <span style={{ fontWeight: 600 }}>Tasa de conversión</span>
          <Tooltip
            title="De los presupuestos que ingresaron al pipeline este período —ya sea en Store o Cliente—, qué porcentaje ya llegó a Comprado, aunque haya cerrado después. En “Hoy” y “Esta semana” puede verse bajo: recién arrancan su recorrido."
            trigger="click"
            color="#fff"
            overlayInnerStyle={{ color: "rgba(0,0,0,0.85)", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
            overlayStyle={{ maxWidth: 240 }}
          >
            <InfoCircleOutlined style={{ fontSize: 12, color: "rgba(0,0,0,0.3)", cursor: "pointer" }} onClick={(e) => e.stopPropagation()} />
          </Tooltip>
        </Flex>
      }
      extra={<Text type="secondary" style={{ fontSize: 11 }}>{nombreDePeriodo(period)}</Text>}
    >
      {status.tipo !== "ok" ? (
        <WidgetPlaceholder status={status} height={bodyH - 24} />
      ) : (
        <>
      <div>
        <Flex align="baseline" gap={8}>
          <Text strong style={{ fontSize: 32, lineHeight: 1 }}>{rate}%</Text>
          <span style={{ fontSize: 11, color, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 2 }}>
            <Icon style={{ fontSize: 9 }} />
            {up ? "+" : ""}{diff}pp vs ant.
          </span>
        </Flex>
        <Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 2 }}>
          {converted} de {total} presupuestos convertidos
        </Text>
      </div>

      <Bar actual={rate} anterior={prevRate} />

      <Flex justify="space-between">
        <Flex align="center" gap={4}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: "#15744b", display: "inline-block" }} />
          <Text style={{ fontSize: 10, color: "rgba(0,0,0,0.35)" }}>Actual {rate}%</Text>
        </Flex>
        <Flex align="center" gap={4}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: "rgba(0,0,0,0.15)", display: "inline-block" }} />
          <Text style={{ fontSize: 10, color: "rgba(0,0,0,0.35)" }}>Anterior {prevRate}%</Text>
        </Flex>
      </Flex>
            </>
      )}
    </Card>
  );
};
